import React, { useState } from "react";
import "./contactus.css";

export default function ContactUs() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("idle"); 
  // idle | loading | success | error
  const [feedback, setFeedback] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !email.includes("@") || message.length < 5) {
      setStatus("error");
      setFeedback("Please provide a valid email and a message.");
      return;
    }

    setStatus("loading");
    setFeedback("");

    try {
      const res = await fetch("https://api.terraweb.africa/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, message }),
      });

      const data = await res.json();

      if (!res.ok) {
        setStatus("error");
        setFeedback(data.message || "Something went wrong.");
        return;
      }

      setStatus("success");
      setFeedback("Message sent successfully! We'll get back to you soon.");
      setEmail("");
      setMessage("");

    } catch (err) {
      setStatus("error");
      setFeedback("Server error, please try again later.");
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-card">
        
        <img 
          src="https://terraweb.africa/logo.png"
          alt="Terraweb Logo"
          className="contact-logo"
        />

        <h2 className="contact-title">Contact Terraweb</h2>
        <p className="contact-subtitle">
          We're here to help. Send us a message and our team will respond shortly.
        </p>

        <form className="contact-form" onSubmit={handleSubmit}>
          <label className="contact-label">Your Email</label>
          <input
            type="email"
            className="contact-input"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setStatus("idle");
            }}
          />

          <label className="contact-label">Message</label>
          <textarea
            className="contact-textarea"
            placeholder="How can we assist you?"
            rows="5"
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
              setStatus("idle");
            }}
          ></textarea>

          <button 
            className="contact-button"
            disabled={status === "loading"}
          >
            {status === "loading" ? (
              <span className="loader"></span>
            ) : (
              "Send Message"
            )}
          </button>
        </form>

        {status === "success" && (
          <p className="contact-success">{feedback}</p>
        )}
        {status === "error" && (
          <p className="contact-error">{feedback}</p>
        )}
      </div>
    </div>
  );
}
